import { render, staticRenderFns } from "./RedeemedVoucherTemplate.vue?vue&type=template&id=fbb7103e&"
import script from "./RedeemedVoucherTemplate.vue?vue&type=script&lang=js&"
export * from "./RedeemedVoucherTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports